<template>
    <v-container fluid grid-list-md class="buy-ip">
        <div class="headline ma-3 text-color-vip bold">
            Hỗ trợ
        </div>
        <div class="container-tabs" v-if="maintain == 0">
            <h1 class="maintain_notice">Chức năng này đang bảo trì</h1>
        </div>
        <template v-else>
            <v-layout row wrap>
                <v-flex xs12>

                    <div class="card">
                        <div class="card-body">
                            <div>
                                <div class="row">
                                    <div class="col-auto">
                                        <v-avatar>
                                            <img :src="avatar_customer" alt="">
                                        </v-avatar>
                                    </div>
                                    <div class="col pl-0">
                                        <h5 class="bold mb-0 text-uppercase font-18">{{ content_question }}</h5>
                                    </div>
                                    <div class="col-auto text-right pl-0">
                                        <h6 class="mb-1 font-14 cl-green">
                                            <i class="mdi mdi-comment-processing-outline"></i> {{ count_reply }} 
                                        </h6>
                                        <h6 class="font-13 cl-green time_elapsed"> {{ time_elapsed }} </h6>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group row type_name">
                                            <div class="col-auto pr-2 font-14 font-bold">
                                                <i class="mdi mdi-circle"></i>Loại hỗ trợ:
                                            </div>
                                            <div class="col pl-0">
                                                <span class="badge text-white font-14 px-3 badge-info">{{ type_name }}</span>
                                            </div>
                                        </div>
                                        <div class="form-group row object_id">
                                            <div class="col-auto pr-2 font-14 font-bold">
                                                <i class="mdi mdi-circle"></i>Id bài viết:
                                            </div>
                                            <div class="col pl-0">
                                                <span class="badge cl-red font-14 px-3 ml-2 bg-red-2 link">{{ object_id }}</span>
                                            </div>
                                        </div>
                                        <div class="form-group row description">
                                            <div class="col-auto pr-2 font-14 font-bold"><i class="mdi mdi-circle"></i><span class="font-bold mr-md-3 mr-0">Mô tả:</span></div>
                                            <div class="col pl-0 ml-md-1">
                                                <div class="ml-md-3">
                                                    <div class="card-body px-2 py-1 content-support">
                                                        <div class="font-14 cl-gray mb-0" v-html="description">{{ description }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="input-group link_ticket">
                                    <v-row class="pb-0">
                                        <v-col cols="8" class="pb-0">
                                            <v-text-field
                                                    single-line
                                                    :value="link_ticket"
                                                    outlined
                                                    disable
                                                    id="link_ticket"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col cols="4" class="pb-0">
                                            <v-btn max-width="160px" class="copy_link" large color="primary" @click="copyLinkTicket">Copy Link Hỗ Trợ</v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                                
                                <div>
                                    <hr class="hr-comment-support my-2">
                                    
                                    <div class="list_reply" v-for="item in item_detail" :key="item.id">
                                        <div v-if="item.type_user === 1" class="card mt-2 card-info-support color_admin">
                                            <div class="card-body py-2">
                                                <div class="row">
                                                    <v-avatar>
                                                        <img :src="avatar_admin" alt="">
                                                    </v-avatar>
                                                    <div class="col pl-2 text-left">
                                                        <h6 class="username">{{ item.customer_name }}</h6>
                                                        <h6 class="time_elapsed">{{ item.time_elapsed }}</h6>
                                                        <div class="font-14 mt-2" v-html="item.content">
                                                            <p>{{ item.content }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    
                                        <div v-else class="card mt-2 card-info-support color_customer" >
                                            <div class="card-body py-2">
                                                <div class="row">
                                                    <v-avatar>
                                                        <img :src="avatar_customer" alt="">
                                                    </v-avatar>
                                                    <div class="col pl-2 text-left">
                                                        <h6 class="username">{{ item.customer_name }}</h6>
                                                        <h6 class="time_elapsed">{{ item.time_elapsed }}</h6>
                                                        <div class="font-14 mt-2" v-html="item.content">
                                                            <p>{{ item.content }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="status == 3" class="row align-items-center mt-5 btn_redirect">
                                    <div class="col-12 pr-1 open">
                                        <button class="btn font-14 btn-rounded bold bg-blue text-white px-3 float-right"
                                                @click="postUpdatStatusTicket()">Mở HT</button>
                                    </div>
                                </div>
                                <div v-else class="row align-items-center mt-5 btn_redirect">
                                    <div class="col-12">
                                        <ckeditor
                                            :editor="editor"
                                            v-model="content"
                                            :config="editorConfig"
                                        />
                                    </div>
                                    <div class="col-4 pr-1 back">
                                        <button class="btn font-14 btn-rounded bg-warning bold bt-green">
                                            <a href="/ticket/list">Trở về</a>
                                        </button>
                                    </div>
                                    <div class="col-4 px-1 reply">
                                        <button type="submit" class="btn font-14 btn-md bg-green text-white btn-block font-bold"
                                                @click="postReplyTicket()">Trả lời</button>
                                    </div>
                                    <div class="col-4 pl-1 close">
                                        <button class="btn font-14 btn-rounded bold bg-red text-white float-right"
                                                @click="postUpdatStatusTicket()">Đóng HT</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </template>
    </v-container>
</template>

<script>
    import {
        CONFIG_PAGE,
        TICKET_GET_DETAIL,
        TICKET_POST_REPLY,
        TICKET_POST_UPDATE_STATUS,
        COMMON_SET_SNACK
    } from "~/store/actions.type";

    import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
    import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
    import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
    import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
    import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
    import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
    import Image from '@ckeditor/ckeditor5-image/src/image';
    import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption';
    import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
    import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
    import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
    import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';
    import SimpleUploadAdapter from '@ckeditor/ckeditor5-upload/src/adapters/simpleuploadadapter';
    import {baseUrl} from "../../config";
    
    export default {
        components: {},
        data() {
            return {
                maintain: 1,
                status: 0,
                ticket_list_id: 0,
                content_question: '',
                content: '',
                contentReplyRules: [
                    v => !!v || 'Vui lòng nhập câu trả lời'
                ],
                object_id: '',
                description: '',
                count_reply: 0,
                time_elapsed: '',
                status_name: '',
                type_name: '',

                link_ticket: '',
                site_url: window.location.protocol + '//' + window.location.host,

                item_detail: {},
                avatar_customer : '',
                avatar_admin : '',

                editor: ClassicEditor,
                editorConfig: {
                    plugins: [
                        EssentialsPlugin,
                        BoldPlugin,
                        ItalicPlugin,
                        LinkPlugin,
                        ParagraphPlugin,
                        Image,
                        ImageCaption,
                        ImageStyle,
                        ImageToolbar,
                        ImageUpload,
                        Alignment,
                        SimpleUploadAdapter
                    ],

                    toolbar: {
                        items: [
                            'bold',
                            'italic',
                            'link',
                            'undo',
                            'redo',
                            'bulletedList',
                            'numberedList',
                            'imageUpload',
                            'blockQuote',
                            'undo',
                            'redo'
                        ]
                    },
                    placeholder:'Nhập câu trả lời',

                    simpleUpload: {
                        uploadUrl: baseUrl+'/tickets/upload',
                    },
                }
            }
        },

        mounted() {
            this.getDataApiTicketDetail();
        },
        methods: {
            postReplyTicket() {
                let params = {
                    id: this.$route.params.id,
                    content: this.content,
                };
                this.$store.dispatch(TICKET_POST_REPLY, params).then(res => {
                    if (res) {
                        let aThis = this;
                        setTimeout(function () {
                            aThis.$router.go();
                        }, 3000);
                    }
                });
            },
            postUpdatStatusTicket() {
                let params = {
                    id: this.$route.params.id
                };
                this.$store.dispatch(TICKET_POST_UPDATE_STATUS, params).then(res => {
                    if (res) {
                        let aThis = this;
                        setTimeout(function () {
                            if (res.status == 3) {//đã đóng
                                aThis.$router.push('/ticket/list/');
                            } else { //đã mở
                                aThis.$router.go();
                            }
                        }, 3000);
                    }
                });
            },
            async getDataApiTicketDetail() {
                await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                    let ticketPageStatus = data.filter(o => o.key == 'key_cp_ticket_customer');
                    this.maintain = parseInt(ticketPageStatus[0]['status']);
                });

                let id = this.$route.params.id;
                this.link_ticket = this.site_url + '/ticket/reply/' + id;
                let data = await this.$store.dispatch(TICKET_GET_DETAIL, {
                    'id': id
                });

                this.avatar_customer = data.avatar.customer;
                this.avatar_admin = data.avatar.admin;
                console.log('this.avatar_admin: '+this.avatar_admin);

                if (data !== false) {
                    let item_list = data.ticket_list;
                    this.count_reply = data.count_reply;

                    this.content_question = item_list.content;
                    this.type_name = item_list.type_name;
                    this.object_id = item_list.object_id;
                    this.description = item_list.description;
                    this.time_elapsed = item_list.time_elapsed;
                    this.status = item_list.status;
                    this.status_name = item_list.status_name;

                    this.item_detail = data.ticket_detail;
                } else {
                    this.$router.push('/ticket/list');
                }
            },
            copyLinkTicket() {
                let testingCodeToCopy = document.querySelector('#link_ticket');
                testingCodeToCopy.setAttribute('type', 'text');
                testingCodeToCopy.select();
                try {
                    document.execCommand('copy');
                    this.$store.dispatch(COMMON_SET_SNACK, {
                        message: 'Đã copy Link hỗ trợ',
                        type: "warning"
                    });
                } catch (err) {
                    console.log('Oops, unable to copy');
                }
            },
        },
    };
</script>
<style lang="scss">
    @import "../../scss/main";

    .text-color {
        color: $mainColor;
        font-weight: bold;
    }

    .color_customer {
        background-color: #d7fbe8;
    }

    .color_admin {
        background-color: #f2f2f2;
    }

    .v-avatar{
        border-radius: unset;
    }
    .font-18 {
        font-size: 120%;
    }

    .text-right {
        padding: 0 12px;
        font-size: 130%;
        color: #1fab89!important;
    }

    .text-right h6{
        font-weight: 400;
    }

    .form-group .col-auto {
        font-weight: bold;
        font-size: 95%;
    }

    .form-group .col-auto i{
        font-size: 7px;
        vertical-align: middle;
        font-weight: 900;
        margin-right: 5px;
        color: #1fab89!important;
    }
    
    .type_name span.badge,
    .object_id span.badge,
    .object_id span.link {
        color: #fff!important;
        border-radius: 20px;
        padding: 3px 10px;
        font-size: 80%!important;
        font-weight: 400!important;
    }
    .type_name span.badge,
    .object_id span.copy{
        background-color: #17a2b8;
    }
    .object_id span.link {
        background-color: #ffe2e5 !important;
        color: #f64e60!important;
    }
    .object_id span.copy:hover,
    .object_id span.link:hover {
        cursor: pointer;
    }
    
    .description .ml-md-1{
        background-color: #f5f7fa!important;
        border-radius: 4px;
    }
    .link_ticket .v-input__slot {
        background-color: #e9ecef !important;
        border-radius: 7px;
    }
    .link_ticket .v-input__slot fieldset {
        color: #fff !important;
    }

    .link_ticket button.copy_link {
        max-width: 150px;
        text-transform: initial;
        margin-top: 10px !important;
    }
    
    .link_ticket {
        height: 80px;
    }
    
    hr {
        border-top: 1px solid rgba(0,0,0,.1);
    }
    
    .list_reply {
        margin-top: 20px;
    }
    .list_reply .card {
        box-shadow: unset;
    }
    .list_reply .v-avatar{
        height: 40px;
        min-width: 40px;
        width: 40px;
    }
    .list_reply .text-left {
        padding-top: 0px;
    }
    .list_reply .text-left .username {
        color: #1fab89!important;
        font-size: 95%;
    }
    .list_reply .text-left .time_elapsed {
        font-size: 80%;
        font-weight: 400;
    }

    .btn_redirect {
        margin: 0;
    }
    .btn_redirect button {
        color: #fff;
        display: inline-block;
        font-weight: 400;
        text-align: center;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        border: 1px solid transparent;
        padding: .7rem 1rem;
        font-size: 1rem;
        line-height: 1.0;
        border-radius: 4px!important;
        font-weight: bold;
    }
    .btn_redirect .reply {
        text-align: center;
    }

    .btn_redirect .back button {
        background-color: #ff9a02!important;
    }
    .btn_redirect .back button a{
        color: #fff !important;
    }
    .btn_redirect .reply button {
        background-color: #1fab89!important;
        width: 80%;
    }
    .btn_redirect .close button {
        background-color: #f64e60!important;
    }
    .btn_redirect .open button {
        background-color: #6993ff!important;
    }

    .type_name .pl-0 {
        margin-left: 9px !important;
    }
    .type_name .col-auto,
    .object_id .col-auto,
    .description .col-auto {
        width: 115px;
    }
    .v-application .ml-2 {
        margin-left: 5px !important;
    }
    .v-application .ml-md-3 {
        margin-left: 12px !important;
    }

    .v-application .pl-2 {
        padding-left: 15px !important;
    }

</style>
